import { createSlice } from '@reduxjs/toolkit';
import { d as LOCAL_STORAGE_SHOW_POINTS } from '../../localStorage-NWX6x-k6.js';

// Load initial state from localStorage if available
const loadInitialState = () => 
// Always return false initially for consistent server/client rendering
({ showPoints: false });
const initialState = loadInitialState();
// Helper function to sync with localStorage
const syncWithLocalStorage = (value) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem(LOCAL_STORAGE_SHOW_POINTS, value ? 'true' : 'false');
    }
};
const pointsSlice = createSlice({
    name: 'points',
    initialState,
    reducers: {
        setShowPoints: (state, action) => {
            state.showPoints = action.payload;
            syncWithLocalStorage(action.payload);
        },
        toggleShowPoints: state => {
            state.showPoints = !state.showPoints;
            syncWithLocalStorage(state.showPoints);
        },
        // Add a hydrate action to sync with localStorage on navigation
        hydratePoints: state => {
            if (typeof window !== 'undefined') {
                const savedShowPoints = localStorage.getItem(LOCAL_STORAGE_SHOW_POINTS);
                state.showPoints = savedShowPoints === 'true';
            }
        },
    },
});
const { setShowPoints, toggleShowPoints, hydratePoints } = pointsSlice.actions;
var pointsSlice$1 = pointsSlice.reducer;
// Selector with proper typing
const selectShowPoints = (state) => { var _a, _b; return (_b = (_a = state.points) === null || _a === void 0 ? void 0 : _a.showPoints) !== null && _b !== void 0 ? _b : false; };

export { pointsSlice$1 as default, hydratePoints, selectShowPoints, setShowPoints, toggleShowPoints };
//# sourceMappingURL=pointsSlice.js.map
